import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Timer } from 'src/interfaces';

const initialPollingTime = 0.5 * 60; // Half min...
const initialState: Timer = {
    initialPollingTime,
    pollingTimeLeft: parseInt(localStorage.getItem('POLLING_TIME_LEFT') ?? '0', 10),
    isPollingActive: !!localStorage.getItem('POLLING_TIME_LEFT'),
    userData: JSON.parse(localStorage.getItem('userDetails') as string),
    initialLiveAPICallTime: 2 * 60 // Two min...
};

export const timerSlice = createSlice({
    name: 'timer',
    initialState,
    reducers: {
        setPollingTimeLeft: (state: Timer, action: PayloadAction<number>) => { state.pollingTimeLeft = action.payload },
        setIsPollingActive: (state: Timer, action: PayloadAction<boolean>) => { state.isPollingActive = action.payload },
        setUserData: (state: Timer, action: PayloadAction<any>) => { state.userData = action.payload },
    },
});

export const { setPollingTimeLeft, setIsPollingActive, setUserData } = timerSlice.actions;

export default timerSlice.reducer;